import React, { Component } from 'react';
import { withRouter } from 'react-router';
import Moment from 'moment';
import HttpService from '../../util/HttpService';
import DatePicker from 'react-datepicker';
import * as LocalStorageManager from '../../util/StorageManager';
import { isDefined, mascaraData, decimalFormat, b64toBlob } from '../../util/Common';
import { Header, Dimmer, Loader, Table, Grid, Form, Input, Segment, Button } from 'semantic-ui-react';
import {toast} from 'react-toastify';
import download from 'downloadjs';

import 'react-datepicker/dist/react-datepicker.css';

class Notas extends Component {

    constructor(){
		super();
		
        this.state = {
			pedido: '',					
			dataInicial: new Moment(),
			dataFinal: new Moment(),
			nota: '',
			serie: '',
			notas: undefined,
			isLoading: false
        }
	}

	componentDidMount(){
        this.buscarNotas();
	}

	buscarNotas = () => {
		const { pedido, nota, serie, dataInicial, dataFinal } = this.state;
		const user = LocalStorageManager.getLoggedUser();

		this.setState({ isLoading: true });

		HttpService.call(
            'consulta/notaFiscal',
			'buscarNotas',
			[
				pedido,
				nota,
				user.idt,
				dataInicial.format('YYYYMMDD'),
				dataFinal.format('YYYYMMDD'),
				LocalStorageManager.getOrigem().idt,				
				serie
			],
			(notas) => this.setState({ notas, isLoading: false })
        );
	}

	buscarNota(idtNota, chaveNota, tipoArquivo) {
        this.setState({isLoading: true});

        HttpService.call(
            'consulta/documento',
            'buscarNota',
            [
                idtNota,
                chaveNota,
                tipoArquivo
            ],
            this.abrirDocumento
        )
	}
	
	buscarBoleto(idtBoleto, numeroFatura) {
        this.setState({isLoading: true});

        HttpService.call(
            'consulta/documento',
            'buscarBoleto',
            [
                idtBoleto,
                numeroFatura
            ],
            this.abrirDocumento
        )
	}
	
	abrirDocumento = (documento) => {
        this.setState({isLoading: false});

        if (isDefined(documento)) {
            download(b64toBlob(documento.data, documento.mimeType), documento.filename, documento.mimeType);
        } else {
            toast.error('Erro ao gerar arquivo. Tente novamente!');
        }
    }

    render() {
		const { pedido, dataInicial, dataFinal, nota, serie } = this.state;

		return (
			<div>
				<Grid centered>
					<Grid.Column mobile={16} tablet={16} computer={16}>						
						<Segment.Group className='white-background'>
							<Segment>
								<Header>Notas Fiscais</Header>
							</Segment>
							<Segment.Group>
								<Segment size='mini' clearing attached='top' secondary>
									<Form size='tiny' onSubmit={() => this.buscarNotas()}>										
										<Form.Group widths='equal'>
											<Form.Field control={DatePicker} required label='Data Inicial' selected={ dataInicial } maxDate={ dataFinal } onChange={ (dataInicial) => this.setState({ dataInicial }) } onChangeRaw={(event) => event.target.value = mascaraData(event.target.value)} />
											<Form.Field control={DatePicker} required label='Data Final' selected={ dataFinal } minDate={ dataInicial } onChange={ (dataFinal) => this.setState({ dataFinal }) } onChangeRaw={(event) => event.target.value = mascaraData(event.target.value)} />
											<Form.Field control={Input} label='Nota' name='nota' value={ nota } onChange={(e, {value}) => this.setState({ nota: value })} />
											<Form.Field control={Input} label='Série' name='serie' value={ serie } onChange={(e, {value}) => this.setState({ serie: value })} />											
											<Form.Field control={Input} label='Pedido' name='pedido' value={ pedido } onChange={(e, {value}) => this.setState({ pedido: value.toUpperCase() })} />
											<Form.Button className='vertical-align-bottom' color='teal' content='Pesquisar' icon='search' compact fluid floated='right' size='medium' type='submit'/>
										</Form.Group>
									</Form>
								</Segment>
								<Dimmer active={this.state.isLoading} inverted>
									<Loader inverted content='Carregando'/>
								</Dimmer>
								<Segment attached className='clean-scrollbar'>
									<Table compact striped selectable singleLine size='small'>
										<Table.Header>
											<Table.Row>
												<Table.HeaderCell width={2} textAlign='center'>Data</Table.HeaderCell>
												<Table.HeaderCell width={2} textAlign='center'>Nota</Table.HeaderCell>
												<Table.HeaderCell width={1} textAlign='center'>Série</Table.HeaderCell>
												<Table.HeaderCell width={2} textAlign='center'>Pedido</Table.HeaderCell>
												<Table.HeaderCell width={1} textAlign='center'>Itens</Table.HeaderCell>
												<Table.HeaderCell width={2} textAlign='right'>Valor (R$)</Table.HeaderCell>
												<Table.HeaderCell width={1} textAlign='center'>NFe</Table.HeaderCell>
												<Table.HeaderCell width={1} textAlign='center'>Boleto</Table.HeaderCell>
											</Table.Row>
										</Table.Header>
										<Table.Body>
										{   
											isDefined(this.state.notas) && this.state.notas.registros > 0 ? (
												this.state.notas.lista.map((item) => {
													return <Table.Row key={item.idt} style={{ cursor: 'pointer' }} onDoubleClick={() => this.props.history.push(this.props.match.url + '/' + item.idt)}>
																<Table.Cell textAlign='center'>{item.dataNota}</Table.Cell>
																<Table.Cell textAlign='center'>{item.nota}</Table.Cell>
																<Table.Cell textAlign='center'>{item.serie}</Table.Cell>
																<Table.Cell textAlign='center'>{item.pedido}</Table.Cell>
																<Table.Cell textAlign='center'>{item.quantidadeItens}</Table.Cell>
																<Table.Cell textAlign='right'>{decimalFormat(item.valorTotal, 2)}</Table.Cell>
																<Table.Cell textAlign='center'>
																	<div>
																		<Button size='mini' title='Baixar PDF' content='PDF' icon='file pdf outline'
																				negative={isDefined(item.idtNFe)} disabled={!isDefined(item.idtNFe)}
																				onClick={() => this.buscarNota(item.idtNFe, item.chaveNFe, 'pdf')}/>
																		<Button size='mini' title='Baixar XML' content='XML' icon='file code outline'
																				positive={isDefined(item.idtNFe)} disabled={!isDefined(item.idtNFe)}
																				onClick={() => this.buscarNota(item.idtNFe, item.chaveNFe, 'xml')}/>
																	</div>
																</Table.Cell>
																<Table.Cell textAlign='center'>
																	<div>
																		<Button size='mini' title='Baixar PDF' content='PDF' icon='file pdf outline'
																				negative={isDefined(item.idtBoleto)} disabled={!isDefined(item.idtBoleto)}
																				onClick={() => this.buscarBoleto(item.idtBoleto, item.numeroFatura)}/>																		
																	</div>
																</Table.Cell>																
															</Table.Row>
												})
											) : (
												<Table.Row>
													<Table.Cell colSpan='8'>Nenhum registro encontrado.</Table.Cell>
												</Table.Row>
											)
										}
										</Table.Body>
									</Table>
								</Segment>
								<Segment size='mini' clearing attached='bottom'>
									<Button negative content='Fechar' floated='left' icon='window close' onClick={() => this.props.history.push('/main')} />
								</Segment>
							</Segment.Group>  
						</Segment.Group>
					</Grid.Column>
				</Grid>				
			</div>
        )
    }
}

export default withRouter(Notas);


// WEBPACK FOOTER //
// ./src/views/Notas/index.js